import React from "react";

import estilo from "./styles/Titulo.module.css";

function Titulo({ titulo, descripcion }) {
  return (
    <div className={estilo.titulo}>
      <h2>{titulo}</h2>
      <div className={estilo.linea}></div>
      <p>{descripcion}</p>
    </div>
  );
}

export default Titulo;
